// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1T5U9","resendInfoText":"OnGoingPaymentBox_resendInfoText__2rrw8"};